module.exports = __webpack_public_path__ + "media/images/landing/iphone-a997868541a5458f7f9eb4fc1a8e1d45.jpg";